<template>
    <BrowsePageContainer />
</template>

<!-- Separate script tag needed for custom fetchData and vuex logic, to be used in entry-server and entry-client -->
<script>
import { SET_404_ERROR } from '~coreModules/core/js/store';

import browseModule, { BROWSE_MODULE_NAME, FETCH_BROWSE_INFORMATION } from '~routes/browse/js/browse-store';
import { getAllBrands } from '~routes/brands/js/brands-api';

const vuex = {
    moduleName: BROWSE_MODULE_NAME,
    module: browseModule,
};

async function fetchData({ route, store, r15Svc }) {
    try {
        const res = await getAllBrands(r15Svc);

        const foundBrand = res?.brands?.find?.(brand => brand.slug === route.params?.slug);
        if (foundBrand) {
            await store.dispatch(`${BROWSE_MODULE_NAME}/${FETCH_BROWSE_INFORMATION}`, {
                slug: 'vendor-brands',
                route: {
                    ...route,
                    query: { ...route.query, vendorBrands: foundBrand.name },
                },
                brandSlug: route.params?.slug,
            });
        } else {
            store.commit(SET_404_ERROR, { message: `Unable to find brand: ${route.params?.slug}` });
        }
    } catch (error) {
        store.commit(SET_404_ERROR, { message: error?.data?.message });
    }
}

export default {
    vuex,
    fetchData,
};
</script>

<script setup>
/* eslint-disable import/first */
import BrowsePageContainer from '~routes/browse/components/BrowsePageContainer.vue';
/* eslint-enable import/first */
</script>

<style lang="scss">

</style>
